import { render, staticRenderFns } from "./MiniProgram.vue?vue&type=template&id=36400862&scoped=true"
import script from "./MiniProgram.vue?vue&type=script&lang=ts"
export * from "./MiniProgram.vue?vue&type=script&lang=ts"
import style0 from "./MiniProgram.vue?vue&type=style&index=0&id=36400862&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36400862",
  null
  
)

export default component.exports